import { Component, AfterViewInit, ViewChild, ElementRef, DoCheck } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import * as encoding from 'encoding-japanese';
import { OwnerService } from '../../../service/owner/owner.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { Observable } from 'rxjs/Rx';

@Component({
  selector: 'app-wa9191',
  templateUrl: './wa9191.component.html',
  styleUrls: ['./wa9191.component.scss']
})
export class Wa9191Component implements AfterViewInit, DoCheck {
  private gridApi: any;
  public componentTitle = 'WA9191:荷主マスタ照会';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public working = false;
  public working2 = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private isShowSearchBlock = true;
  private isEnableClearFilter = null;
  private selectedCount = 0;
  private isShowSendLoading = false;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;
  private delete: boolean = false;
  public wa9193Data: object = [];

  private ownerResult: any;
  private ownerId: number;

  constructor(private router: Router, private ownerService: OwnerService, private commonService: CommonService) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      pagination: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9191_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.gridHelper.renderGridCheckboxImage();
        this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
        this.selectedCount = 0;
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        if (this.gridOptions.rowData && this.gridOptions.rowData.length > 0) this.gridHelper.isShowGridNoDataOverlay = false;
        else this.gridHelper.isShowGridNoDataOverlay = true;
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        headerCheckboxSelection: false,
        suppressMenu: true,
        pinned: 'left',
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        sort: 'asc',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主正式名１',
        field: 'ownerfullname1Tx',
        width: this.getColumnWidth('ownerfullname1Tx', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主正式名２',
        field: 'ownerfullname2Tx',
        width: this.getColumnWidth('ownerfullname2Tx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主表示名',
        field: 'ownerdisplayTx',
        width: this.getColumnWidth('ownerdisplayTx', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '財務相手先コード',
        field: 'owneraccCd',
        width: this.getColumnWidth('owneraccCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '郵便番号',
        field: 'ownerpostalCd',
        width: this.getColumnWidth('ownerpostalCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '住所',
        field: 'owneraddressTx',
        width: this.getColumnWidth('owneraddressTx', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '電話番号',
        field: 'ownertelTx',
        width: this.getColumnWidth('ownertelTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '請求・締め日',
        field: 'bookendTx',
        width: this.getColumnWidth('bookendTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '請求・保管期数',
        field: 'invstockfreqTx',
        width: this.getColumnWidth('invstockfreqTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      // {
      //   headerName: '着日印刷順',
      //   field: 'delimemodelidateNr',
      //   width: this.getColumnWidth('delimemodelidateNr', 100),
      // },
      // {
      //   headerName: '出荷明細摘要印刷順',
      //   field: 'delimemomemodetNr',
      //   width: this.getColumnWidth('delimemomemodetNr', 100),
      // },
      // {
      //   headerName: '受注番号印刷順',
      //   field: 'delimemoordernoNr',
      //   width: this.getColumnWidth('delimemoordernoNr', 100),
      // },
      // {
      //   headerName: '商品情報印刷順',
      //   field: 'delimemoitemNr',
      //   width: this.getColumnWidth('delimemoitemNr', 100),
      // },
      {
        headerName: 'ヤマト・発ベース№',
        field: 'yamatobasenoCd',
        width: this.getColumnWidth('yamatobasenoCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      // {
      //   headerName: '着日指定表示フラグ',
      //   field: 'delidateTx',
      //   width: this.getColumnWidth('delidateTx', 100),
      // },
      // {
      //   headerName: '商品名表示フラグ',
      //   field: 'itemnameTx',
      //   width: this.getColumnWidth('itemnameTx', 100),
      // },
      // {
      //   headerName: '出荷時摘要表示フラグ',
      //   field: 'memodetTx',
      //   width: this.getColumnWidth('memodetTx', 100),
      // },
      // {
      //   headerName: '出荷時摘要表示フラグ（納品書）',
      //   field: 'memodetinveTx',
      //   width: this.getColumnWidth('memodetinveTx', 150),
      // },
      // {
      //   headerName: '送料計上フラグ',
      //   field: 'delipriceTx',
      //   width: this.getColumnWidth('delipriceTx', 100),
      // },
      {
        headerName: '倉庫名',
        field: 'whTx',
        width: this.getColumnWidth('whTx', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '営業所名',
        field: 'salesofficeTx',
        width: this.getColumnWidth('salesofficeTx', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 200),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.gridHelper.setGridOptions(this.gridOptions);
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9191_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9191_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa9191_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];
    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  ngAfterViewInit() {
    sessionStorage.removeItem('isShowOwnerSelect');
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.onSubmit();
  }

  reg() {
    sessionStorage.setItem('wa9192openotherwindow', 'open');
  }

  upd() {
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    this.wa9193Data = this.rowData[selectedIndex];
    sessionStorage.setItem('wa9193openotherwindow', 'open');
  }

  del() {
    this.isShowSendLoading = true;
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    const selectedId = this.rowData[selectedIndex]['ownerId'];
    //SW-2097　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;
    this.ownerService
      .delete(selectedId)
      .then(outputJson => {
        this.delete = false;
        this.isShowSendLoading = false;
        this.working2 = false;
        this.onSubmit();
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowSendLoading = false;
        this.delete = false;
        this.working2 = false;
      });
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;
    this.gridOptions.api.showLoadingOverlay();
    this.onFilterClear();
    this.ownerService
      .get()
      .then(outputJson => {
        this.rowData = outputJson.owners;

        this.gridHelper.prepareSelectedAnimateByNodes(this.gridOptions.api.getSelectedNodes());
        if (sessionStorage.getItem('wa9193upd') === 'ok') {
          Observable.timer(100).subscribe(() => {
            this.gridHelper.selectedAnimate();
          });
          sessionStorage.removeItem('wa9193upd');
        }
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working2 = false;
        },300);
      })
      .catch(error => {
        this.working2 = false;
        this.gridOptions.api.hideOverlay();
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngDoCheck() {
    if (this.selectedCount > 0) {
      this.working = true;
    } else {
      this.working = false;
    }
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9191/wa9191.component.ts